import { useEffect, useState } from "react";

import logo from './assets/logo.png'
import Header from './components/Header';
import Page from './components/Page'
import Inicio from './pages/Inicio';
import PosiçãoDoAnalista from './pages/PosiçãoDoAnalista'
import JacquesLacan from './pages/JacquesLacan'
import Pagamento from './pages/Pagamento'
import Toxicomanias from "./pages/toxicomanias";

import './App.css';

function App() {
 const [page, setPage] = useState("início");

 useEffect(() => {
  document.title = "Psicanálise"
  const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
  link.type = 'image/x-icon'
  link.rel = 'icon'
  link.href = logo
  document.getElementsByTagName('head')[0].appendChild(link)
 })

  return (
    <div className="App">
      <Header onPageChange={setPage} />
      <Page>
        {page === "início" && <Inicio />}
        {page === "posição-do-analista" && <PosiçãoDoAnalista />}
        {page === "jacques-lacan" && <JacquesLacan />}
        {page === "pagamento" && <Pagamento />}
        {page === "toxicomanias" && <Toxicomanias />}
      </Page>
    </div>
  );
}

export default App;



function soma(a, b) {
  return a + b;
}


soma(3, 5)